export default __webpack_public_path__ + "static/media/pic2.94a5bb87.jpg";